import { composeIO } from 'react-compose-io'
import { itemConfiguracoesGeraisIO } from './ItemConfigiracoesGerais.IO'
import { ItemConfiguracoesGeraisView } from './ItemConfiguracoesGerais.View'

export const ItemConfiguracoesGerais = composeIO(ItemConfiguracoesGeraisView, itemConfiguracoesGeraisIO)
